import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../enums/queryKeys'
import { UserOrganizationMembership } from '../types/userOrganizationMembership'
import { useUserOrganization } from '../userOrganizationContext'

/**
 * This hook is a cache reader, enabled: false will prevent a redundant network call.
 * The data is seeded into the cache from the Ember.
 */
export const useUserOrganizationMembership = () => {
  const { organization } = useUserOrganization()
  const { data: membership } = useQuery<UserOrganizationMembership>(
    [QueryKeys.UserOrganizationMembership, organization?.id],
    { enabled: false },
  )

  return { membership, isViaUmbrella: membership?.via === 'umbrella' }
}
